import { useRequest } from "@certn/api";
import { showToast } from "@certn/cascadia";
import {
  DangerButton,
  Divider,
  Layout,
  Text,
  Container,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useStyles } from "./styles";
import { AppFooter } from "../../components/app-footer";
import { AppHeader } from "../../components/app-header";

export function DeclineCredentialRequest() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const clientName = searchParams.get("client_name");
  const { credentialRequestId } = useParams();
  const styles = useStyles();
  const request = useRequest();

  const navigate = useNavigate();
  const handleDeclineCredentialRequest = async () => {
    try {
      await request(
        `/api/internal/wallet/holder/credential-requests/${credentialRequestId}/decline/`,
        {
          method: "POST",
        }
      );
      navigate(`/credential-request-declined?client_name=${clientName}`);
    } catch (e) {
      console.error("Error declining the invite:", e);
      showToast(t("Something went wrong, try again"), {
        type: "error",
      });
    }
  };
  return (
    <Layout
      layout="auth"
      header={<AppHeader hideSettings showLoginButton />}
      footer={<AppFooter />}
    >
      <Container>
        <div className={styles.container}>
          <div>
            <Text as="h2" style="form/page-title">
              <Trans>Decline request</Trans>
            </Text>
          </div>
          <div>
            <Text style="form/body-primary" color="text-weak">
              <Trans>
                If you've decided not to proceed with the credential request for{" "}
                {{ clientName }} select the “Decline request“ button below. Upon
                confirmation, {{ clientName }} will be notified and the request
                will be cancelled.
              </Trans>
            </Text>
          </div>
          <div>
            <Text style="form/body-primary" color="text-weak">
              <Trans>Please note this action cannot be undone.</Trans>
            </Text>
          </div>
          <DangerButton
            testID="decline-request-button"
            size="large"
            onPress={handleDeclineCredentialRequest}
            fullWidth
          >
            <Trans>Decline request</Trans>
          </DangerButton>
          <Divider />
          <div>
            <Text style="form/body-primary" color="text-weak">
              <Trans>
                If you do not want to decline the request, simply close this
                tab.
              </Trans>
            </Text>
          </div>
        </div>
      </Container>
    </Layout>
  );
}
